import { z } from "zod";

export const mapInfoSchema = z.object({
  content: z.string()
});

export type MapInfo = z.infer<typeof mapInfoSchema>;
